module.exports = __webpack_public_path__ + "static/media/03_insideyourblood.38d586a0.jpg";